export default __webpack_public_path__ + "static/media/Envizo_1.9b278515.PNG";